import React from 'react'
import classnames from 'classnames/bind'
import { Divider } from '@adc/ui-adc'
import { MarginSection } from 'common/modules/bidBanner/container'
import styles from './styles.scss'
import FAQLink from './faqLink'
const cx = classnames.bind(styles)

export default function FAQSection() {
  return (
    <MarginSection
      containerClassName={cx('container')}
      data-elm-id='faq_section'
      left
      right
    >
      <Divider />
      <FAQLink />
    </MarginSection>
  )
}
